import { mapActions } from 'vuex';
import { firebase } from './firebase.js';

export default {
  methods: {
    ...mapActions(['setFirebaseSignin']),
    async authenticateUser(token) {
      try {
        await firebase.auth().signInWithCustomToken(token);
        console.log('finish sign in');
      } catch (error) {
        this.firebaseAuthSignout();
      }
    },
    authStateChanged() {
      firebase.auth().onAuthStateChanged((user) => {
        if (user) {
          this.setFirebaseSignin(true);
          console.log('user connected', user);
        } else {
          this.setFirebaseSignin(false);
          console.log('firebase authStateChanged : user not connected');
        }
      });
    },
    firebaseAuthSignout() {
      try {
        firebase.auth().signOut();
        console.log('User Logged Out!');
      } catch (err) {
        console.log('err:', err);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/assets/js/firebaseMixins.js